/**
 * Translates muscle group / body part names from ExerciseDB API
 * into the user's current language via i18n keys.
 *
 * Usage:
 *   const label = translateMuscle("chest", t);
 *   // → "Peito" (PT-BR), "Borst" (NL), "Chest" (EN)
 */

const MUSCLE_KEY_MAP: Record<string, string> = {
  // Primary body parts (ExerciseDB "bodyPart" field)
  back: "fitness.muscle.back",
  cardio: "fitness.muscle.cardio",
  chest: "fitness.muscle.chest",
  "lower arms": "fitness.muscle.forearms",
  "lower legs": "fitness.muscle.calves",
  neck: "fitness.muscle.neck",
  shoulders: "fitness.muscle.shoulders",
  "upper arms": "fitness.muscle.arms",
  "upper legs": "fitness.muscle.legs",
  waist: "fitness.muscle.core",

  // Target muscles (ExerciseDB "target" field)
  abs: "fitness.muscle.abs",
  adductors: "fitness.muscle.adductors",
  biceps: "fitness.muscle.biceps",
  calves: "fitness.muscle.calves",
  "cardiovascular system": "fitness.muscle.cardio",
  delts: "fitness.muscle.shoulders",
  deltoids: "fitness.muscle.shoulders",
  "rear deltoids": "fitness.muscle.rearDeltoids",
  forearms: "fitness.muscle.forearms",
  glutes: "fitness.muscle.glutes",
  hamstrings: "fitness.muscle.hamstrings",
  lats: "fitness.muscle.lats",
  "levator scapulae": "fitness.muscle.traps",
  pectorals: "fitness.muscle.chest",
  quads: "fitness.muscle.quads",
  "serratus anterior": "fitness.muscle.core",
  spine: "fitness.muscle.back",
  traps: "fitness.muscle.traps",
  triceps: "fitness.muscle.triceps",
  "upper back": "fitness.muscle.back",

  // Common shorthand used in plan generator
  arms: "fitness.muscle.arms",
  core: "fitness.muscle.core",
  legs: "fitness.muscle.legs",
};

/**
 * Translate a muscle/body-part string from ExerciseDB to the current locale.
 * Falls back to the original string (capitalized) if no mapping exists.
 */
export function translateMuscle(
  muscle: string,
  t: (key: string) => string,
): string {
  const key = MUSCLE_KEY_MAP[muscle.toLowerCase()];
  if (key) return t(key);
  // Capitalize first letter as fallback
  return muscle.charAt(0).toUpperCase() + muscle.slice(1);
}
